/**
 * Mapping of OM1 to SPM lower-case card/face names.
 */
export const OM1_SPM_CARD_NAME_MAPPING = Object.freeze({
  "rhilex the accursed": "agent venom",
  "aggressive symbiosis": "alien symbiosis",
  "drix interception": "amazing acrobatics",
  "galvanized workforce": "angry rabble",
  "verilax the havenskin": "anti-venom, horrifying healer",
  "yera and oski, weaver and guide": "arachne, psionic weaver",
  "gloria, the great armorer": "araña, heart of the spider",
  "zora, spider fancier": "aunt may",
  "perfected pastry": "bagel and schmear",
  "arala, hedron scaler": "beetle, legacy criminal",
  "hex of undeath": "behold the sinister six!",
  "angler's shield": "biorganic carapace",
  "wrench, speedway saboteur": "black cat, cunning thief",
  "desecrex, gift of servitude": "carnage, crimson chaos",
  "vazin, two-faced trickster": "chameleon, master of disguise",
  "scions of the ur-spider": "cosmic spider-man",
  "fearsome ridgeline": "daily bugle building",
  "principled referee": "daily bugle reporters",
  "selesnya archivist": "damage control crew",
  "obscura alleylurkers": "doc ock's henchmen",
  "ozor, chronicler of collapse": "doc ock, sinister scientist",
  "giantcraft helm": "doc ock's tentacles",
  "neach, pinnacle pariah": "doctor octopus, master planner",
  "viggo, enforcer of ig's crossing": "eddie brock",
  "viggo, end of ig's crossing": "venom, lethal protector",
  "bayo, irritable instructor": "electro, assaulting battery",
  "deathflame burst": "electro's bolt",
  "orris, last of the web lords": "ezekiel sims, spider-totem",
  "basil, cabaretti loudmouth": "flash thompson, spider-fan",
  "vexed bots": "flying octobot",
  "remarkable readings": "friendly neighborhood",
  "nu and sumi, career criminals": "green goblin, revenant",
  "eccentric arachnologist": "guy in the chair",
  "egrix the bile bulwark": "gwenom, remorseless",
  "nia, skysail storyteller": "gwen stacy",
  "nia, fabled skyclimber": "ghost-spider",
  "fire-brained scheme": "heroes' hangout",
  "spectral restitching": "hide on the ceiling",
  "cam and farrik, havoc duo": "hobgoblin, mantled marauder",
  "treat trolley": "hot dog cart",
  "belion, the parched": "hydro-man, fluid felon",
  "caldaia brawlers": "inner demons gangsters",
  "reality fulcrum": "interdimensional web watch",
  "fizik, etherium mechanic": "iron spider, stark upgrade",
  "druneth, reviver of the hive": "jackal, genius geneticist",
  "lazlo, enthusiastic accuser": "j. jonah jameson",
  "perilous lunge": "kapow!",
  "dreadfang, loathed by fans": "kraven, proud predator",
  "cruel caracals": "kraven's cats",
  "a trail of teacups": "kraven's last hunt",
  "brako, heartless hunter": "kraven the hunter",
  "merata, neuron hacker": "lady octopus, inspired inventor",
  "error-9, viral node": "living brain, mechanical marvel",
  "king of the coldblood curse": "lizard, connors's curse",
  "olx, mouth to many eyes": "madame web, clairvoyant",
  "demera, soul of a spider": "mary jane watson",
  "skittering kitten": "masked meower",
  "lavabrink repels the magmaloth": "maximum carnage",
  "data scrubber": "mechanical mobster",
  "cren, undercity dreamer": "miles morales",
  "cren of the spider brood": "ultimate spider-man",
  "withar, cocoon keeper": "mister negative",
  "the infernus": "molten man, inferno incarnate",
  "tearle, entropic hunger": "morbius the living vampire",
  "luis, pompous pillager": "morlun, devourer of spiders",
  "the watcher on the road": "mysterio, master of illusion",
  "phantasmal vision": "mysterio's phantasm",
  "opulent valet": "news helicopter",
  "goben, gene-splice savant": "norman osborn",
  "fleem, goben's creation": "green goblin",
  "a most helpful weaver": "origin of spider-man",
  "exclusive nightclub": "oscorp industries",
  "pinnacle research team": "oscorp research team",
  "duskmourn's claim": "parker luck",
  "carriage of dreams": "passenger ferry",
  "surris, spidersilk innovator": "peter parker",
  "surris, silk-tech vanguard": "amazing spider-man",
  "phenomena recorder": "peter parker's camera",
  "ancestral carvings": "pictures of spider-man",
  "favored fighter": "professional wrestler",
  "carlo, suave schemer": "prowler, clawed thief",
  "knife trick": "pumpkin bombardment",
  "fateweaver": "radioactive spider",
  "lavaborn goblins": "raging goblinoids",
  "confessor's bindings": "rent is due",
  "xecau, predation's shadow": "rhino, barreling brute",
  "clandestine work": "risky research",
  "stitcher's wings": "rocket-powered goblin glider",
  "the scouring stormsoul": "sandman, shifting scoundrel",
  "miasmic mist": "sandman's quicksand",
  "borys, the spider rider": "scarlet spider, ben reilly",
  "kivni, orb weaver": "scarlet spider, kaine",
  "outsmart the amateur": "school daze",
  "scorvus ames, crimelord": "scorpion, seething striker",
  "crime-scene instructor": "selfless police captain",
  "quint's insight": "shadow of the goblin",
  "kazuo, ruthless rival": "shocker, unshakable",
  "crash, reckless endrider": "shriek, treblemaker",
  "alenni, brood recruiter": "silk, web weaver",
  "generous betty wray": "silver sable, mercenary leader",
  "wonderweave aerialist": "skyward spider",
  "kumonosu, the watchful": "sp//dr, piloted by peni",
  "ademi of the silkchutes": "spectacular spider-man",
  "steelweb surveyor": "spider-bot",
  "argyr, tidal spinner": "spider-byte, web warden",
  "janai and hoppy, roofskippers": "spider-girl, legacy hero",
  "wardens of silverweb summit": "spider-gwen, free spirit",
  "tarantusk, unwisely awoken": "spider-ham, peter porker",
  "sadistic string-puller": "spider-islanders",
  "uharis, the stormspinner": "spider-man 2099",
  "zan, tunnelweb explorer": "spider-man, brooklyn visionary",
  "leyline weaver": "spider manifestation",
  "alessos and pras, acrobats": "spider-man india",
  "kroble, envoy of the bog": "spider-man noir",
  "hide in mundanity": "spider-man no more",
  "darval, whose web protects": "spider-man, web-slinger",
  "scuttling spidercoach": "spider-mobile",
  "kraza, the swarm as one": "spider-punk",
  "chizak, apex arachnosaur": "spider-rex, daring dino",
  "detect intrusion": "spider-sense",
  "goro rel, scourge to spiders": "spider-slayer, hatred honed",
  "the clutter cluster": "spiders-man, heroic horde",
  "cactarantula saddle": "spider-suit",
  "sarn of the silken throne": "spider-uk",
  "arachnomania": "spider-verse",
  "makdee and itla, skysnarers": "spider-woman, stunning savior",
  "rizna, the spider-crowned": "spinneret and spiderling",
  "eztli of the thousand moons": "starling, aerial ally",
  "temple trap": "steel wrecking ball",
  "kephon, rage incubator": "stegron the dinosaur man",
  "vinewoven chariot": "subway train",
  "cirina bargainspinner": "sun-spider, nimble webber",
  "restless razorkin": "superior foes of spider-man",
  "kavaero, mind-bitten": "superior spider-man",
  "wekhdu, midnight hunter": "swarm, being of bees",
  "skv'x the augmenter": "symbiote spider-man",
  "full-throttle fanatic": "taxi driver",
  "lost in littjara": "the clone saga",
  "the house grows hungry": "the death of gwen stacy",
  "the terminus of return": "the soul stone",
  "qoneus, horizon splicer": "the spot, living portal",
  "remorseless coup": "the spot's portal",
  "lively leap": "thwip!",
  "nill, vessel of valgavoth": "tombstone, career criminal",
  "ruzic, booed but victorious": "ultimate green goblin",
  "tethex, gift of malice": "venom, evil unleashed",
  "bane-marked leonin": "venomized cat",
  "damning caress": "venom's hunger",
  "rishei, getaway accomplice": "vulture, scheming scavenger",
  "rouse the swarm": "wall crawl",
  "through the omenpath": "web of life and destiny",
  "archangler's skyrod": "web-shooters",
  "mothwing shroud": "web up",
  "diligent webkeepers": "web-warriors",
  "snatch back": "whoosh!",
  "freestrider aces": "wild pack squad",
  "chosen by valgavoth": "with great power...",
  "margot, on the case": "wraith, vicious vigilante"
});
